import {GetLogsRequest} from '../models/logging/getLogs.request';

// tslint:disable-next-line:no-namespace
export namespace Logging {
  export class GetLogs {
    static readonly type = '[Logging api] Get Logs';

    constructor(public request: GetLogsRequest) {
    }
  }
}
